export const searchListName = "Search";
export const solutionListName = "Solution";
const myAccountOrderHistoryName = "my_account_orders", myAccountWishListId ="my_account_lists";

export const onProductSearchResultsUpdate = (searchResults, listName) => {
   onProductResultsUpdate(searchResults, listName, true)
}

export const onSolutionResultsUpdated = (searchResults, listName) => {
   onProductResultsUpdate(searchResults, listName)
}

export const onWishListResultsUpdated = (itemLists) => {
    var results = itemLists.Items.map(x => x.GoogleTagManagerProductFieldObject);
    var resultsWithViewName = getResultsWithViewName(results, itemLists.Name, myAccountWishListId);
    window.gtm.viewItemList(resultsWithViewName, myAccountWishListId, "");
}

export const onMyAccountOrderHistoryUpdated = (itemResults) => {
    let viewItems = [];
    itemResults.forEach(function (itemArray) {
        itemArray[0].forEach(function (item) {
            viewItems.push({
                Name: item.Name,
                Id: item.Code,
                Price: item.UnitPrice.replace('$',''),
                Brand: item.Brand,
                Category: item.Category,
                Variant: item.VariantName
            });
        });
    });
    var resultsWithViewName = getResultsWithViewName(viewItems, myAccountOrderHistoryName, myAccountOrderHistoryName);
    window.gtm.viewItemList(resultsWithViewName, myAccountOrderHistoryName, "");
}

export const onProductResultClick = (product, list) => {
   if(window && window.gtm && window.gtm.productClick) {
      window.gtm.productClick(product, list);
   }
}

const onProductResultsUpdate = (searchResults, listName, isFromSearch = false) => {
    if (window && window.gtm && window.gtm.viewItemList) {
        
        let results = searchResults.Results.map(result => result.GoogleTagManagerProductFieldObject);

        var resultsWithViewName = getResultsWithViewName(results, (isFromSearch ? searchResults.SearchString : searchResults.GtmCategoryName), (searchResults.SearchString === "" ? "pcp" : searchResults.SearchString));
        window.gtm.viewItemList(resultsWithViewName,
                               listName,
                               searchResults.SearchString,
                               searchResults.Pagination.CurrentPageIndex * searchResults.Pagination.CurrentItemsPerPage,
                               searchResults.Pagination.CurrentItemsPerPage
                              );
   }
}

const getResultsWithViewName = (results, CatagoryName, searchString) => { 
    let fullResults = results.map(item => ({ ...item, item_list_name: CatagoryName, item_list_id: searchString }));
    return fullResults;
}